module.exports = __webpack_public_path__ + "static/media/external-link-alt-hover.0a737479.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/external-link-alt-hover.png
// module id = 304
// module chunks = 0